export default __webpack_public_path__ + "static/media/material.226b1254.png";